
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","viewBox":"0 0 18 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.6235 2.54789C17.5192 2.17407 17.3202 1.83349 17.0458 1.55906C16.7714 1.28463 16.4308 1.08563 16.057 0.981304C14.6539 0.605415 9.00734 0.605415 9.00734 0.605415C9.00734 0.605415 3.37499 0.597912 1.95772 0.981304C1.5839 1.08563 1.24332 1.28463 0.968888 1.55906C0.694458 1.83349 0.495463 2.17407 0.391136 2.54789C0.125178 3.9843 -0.00594094 5.44243 -0.000509332 6.90325C-0.00491412 8.35856 0.1262 9.81112 0.391136 11.2421C0.495463 11.6159 0.694458 11.9565 0.968888 12.2309C1.24332 12.5054 1.5839 12.7044 1.95772 12.8087C3.35924 13.1853 9.00734 13.1853 9.00734 13.1853C9.00734 13.1853 14.6389 13.1853 16.057 12.8087C16.4308 12.7044 16.7714 12.5054 17.0458 12.2309C17.3202 11.9565 17.5192 11.6159 17.6235 11.2421C17.8829 9.8106 18.0085 8.35805 17.9987 6.90325C18.0096 5.44295 17.884 3.98482 17.6235 2.54789ZM7.20517 9.5975V4.20075L11.9049 6.90325L7.20517 9.5975Z","fill":"currentColor"}})])
          )
        }
      }
    